import { createContext, useContext, ReactNode } from 'react';

/**
 * Идентичность клиента с точки зрения ядра — КТО вошёл, независимо от того,
 * как он вошёл (Telegram initData или телефон+cookie). Заполняет шелл.
 */
export interface CoreIdentity {
  status: 'loading' | 'authenticated' | 'anonymous';
  /** Telegram ID входа Telegram (мини-апп); в PWA — null. Экраны от него не зависят: клиент — из сессии
   * (K-002), а Telegram ID уходит в запросы только как необязательная сверка (api/session.ts). */
  telegramId: number | null;
  /** UUID клиента — известен сразу в PWA; в mini-app появляется из профиля. */
  userId: string | null;
  firstName: string | null;
}

const IdentityContext = createContext<CoreIdentity | null>(null);

export function IdentityProvider({ value, children }: { value: CoreIdentity; children: ReactNode }) {
  return <IdentityContext.Provider value={value}>{children}</IdentityContext.Provider>;
}

export function useIdentity(): CoreIdentity {
  const ctx = useContext(IdentityContext);
  if (!ctx) {
    throw new Error('useIdentity must be used within IdentityProvider');
  }
  return ctx;
}
